/* eslint-disable react/no-array-index-key */
import { useContext } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import AppContext from '../../context/AppContext';
import { US_CONTENT } from '../../utils/geoBlock';

import ChefsHostsDetails from './ChefsHostsDetails';

import FallbackImage from '../../inline-images/post-fallback-image.jpg';

export default function ChefsHostsBlock({ fncStars }) {
	const { isUsTraffic } = useContext(AppContext);

	if (!fncStars) return null;

	const stars = fncStars.map((star) => {
		const {
			authorId,
			authorShows,
			details,
			key,
			slug,
			title,
			usersProfilePicture,
		} = star;

		// Ads Element
		if (key !== undefined) {
			return star;
		}

		let profilePic = '';
		if (details?.authorType === 'Chef' || details?.authorType === 'Host') {
			profilePic = usersProfilePicture?.sourceUrl;
		} else {
			profilePic = FallbackImage;
		}

		if (!profilePic) {
			profilePic = FallbackImage;
		}

		const profileAltTxt = usersProfilePicture?.altText || 'Flavour Network';
		const profileLink = `/profile/${slug}/`;
		const profileTitle = title || 'Flavour Network';

		// Removes any shows which are deemed invalid
		const validateShows = (shows) => {
			// Hide US Shows from geo-blocked users
			if (authorShows?.length > 0 && isUsTraffic) {
				return shows.filter((show) => {
					const { distributions } = show;
					return distributions.length === 0
						|| distributions.every((item) => item !== US_CONTENT);
				});
			}
			return shows;
		};

		const shows = validateShows(authorShows);

		// Chefs & Hosts
		if (authorId) {
			const maxShowTags = 5;
			const tags = shows?.length > 0 && shows.slice(0, 5).map((tag, index) => (
				<li key={`${index}${tag.id}`}>
					<Link href={`/tag/${tag.slug}/`}>

						<span>{tag.name}</span>
						{shows.length === index + 1 || index + 1 === maxShowTags ? '' : ',\u00A0'}

					</Link>
				</li>
			));

			return (
				<ChefsHostsDetails
					details={{
						authorId,
						profileAltTxt,
						profileLink,
						profilePic,
						profileTitle,
						tags,
					}}
					key={authorId}
				/>
			);
		}

		return null;
	});

	return (
		<div className="chefs-hosts">
			<h1>Chefs & Hosts</h1>
			<div className="chefs-hosts__grid">
				{stars}
			</div>
		</div>
	);
}

ChefsHostsBlock.propTypes = {
	fncStars: PropTypes.array.isRequired,
};
